module.exports = __webpack_public_path__ + "media/images/icons/outlined/format-painter-a88033049ce7af6eab32a48204642077.svg";